var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 313,
    viewBox: "0 0 321 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3904 265.505C54.4652 273.828 61.6892 278.721 67.2207 282.414C121.168 318.435 182.835 308.053 201.902 304.505C232.663 298.779 258.629 294.74 280.939 274.585C331.634 228.784 329.167 133.241 290.43 74.0557C285.838 67.0385 247.16 9.70565 185.359 1.6264C183.847 1.42853 182.719 1.31673 181.731 1.21165C172.17 0.195451 112.929 -5.14488 64.6182 35.324C57.7039 41.1171 46.5749 51.5675 36.2553 67.5046C-1.47693 125.782 -1.59653 216.038 46.3904 265.505Z",
    fill: "url(#paint0_linear_436_29128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.89 13.4864C321.541 11.5859 318.932 10.0208 317.12 11.2114C298.72 23.3275 253.691 60.6114 256.704 133.889C260.487 225.827 235.322 256.737 206.091 274.21C206.091 274.21 244.423 268.437 271.285 237.207C337.236 160.53 309.318 47.2936 320.89 13.4864Z",
    fill: "#91B3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.717 230.569C236.896 233.576 240.764 234.401 243.095 232.167C255.971 219.842 289.224 181.703 284.235 120.375C280.023 68.5858 282.663 40.1077 284.756 27.2572C285.203 24.5395 281.916 22.8369 279.948 24.7597C258.223 45.9724 192.966 121.603 235.717 230.569Z",
    fill: "#7D97F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.088 230.487C240.159 230.532 240.234 230.569 240.312 230.599C240.624 230.719 240.971 230.71 241.277 230.574C241.582 230.438 241.821 230.186 241.941 229.874C242.225 229.137 270.212 155.333 267.611 83.0597C267.605 82.8942 267.566 82.7315 267.497 82.5808C267.428 82.4302 267.331 82.2946 267.209 82.1817C267.088 82.0689 266.946 81.981 266.791 81.9232C266.635 81.8653 266.47 81.8386 266.305 81.8446C266.139 81.8505 265.977 81.889 265.826 81.9578C265.675 82.0267 265.54 82.1245 265.427 82.2458C265.314 82.367 265.226 82.5093 265.168 82.6645C265.11 82.8197 265.084 82.9848 265.09 83.1503C267.672 154.898 239.868 228.237 239.586 228.969C239.481 229.241 239.474 229.541 239.566 229.818C239.657 230.095 239.842 230.331 240.088 230.487Z",
    fill: "#91B3FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.522 1.23004C258.665 1.93768 264.908 8.75703 264.931 16.9302C265.073 66.9149 265.307 239.321 262.049 300.345C261.884 303.458 260.539 306.392 258.287 308.549C256.036 310.707 253.048 311.925 249.93 311.957C217.911 312.302 125.81 312.936 73.521 309.591C62.6301 308.894 54.1562 299.875 54.1685 288.962C54.2323 236.502 55.0707 88.9649 62.2567 21.5305C62.6734 17.6159 64.4474 13.9708 67.2709 11.2277C70.0945 8.48461 73.7894 6.81667 77.7143 6.51336C112.638 3.79344 205.376 -2.69612 250.522 1.23004Z",
    fill: "url(#paint1_linear_436_29128)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.066 30.0335C252.696 72.7896 254.485 215.023 251.36 267.52C250.904 275.192 244.943 281.25 237.583 281.508C207.288 282.563 129.58 284.606 85.303 279.734C77.3311 278.857 71.2373 271.947 71.0249 263.579C69.917 219.946 66.9254 87.4714 69.9628 35.5627C70.448 27.2811 76.7743 20.6742 84.7049 20.1353C117.514 17.9241 201.764 12.8263 239.415 15.961C246.483 16.5546 251.958 22.6306 252.066 30.0335Z",
    fill: "#91B3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 8.66151C178.858 9.22997 178.629 9.77231 178.229 10.1765C177.829 10.5808 177.289 10.816 176.721 10.8336C170.891 11.0103 154.467 11.5133 147.125 11.7772C146.788 11.7891 146.452 11.7239 146.144 11.5866C145.836 11.4493 145.563 11.2434 145.346 10.9847C145.129 10.726 144.974 10.4212 144.893 10.0936C144.812 9.766 144.806 9.42417 144.877 9.09415C144.902 9.04943 145.09 7.23392 146.944 7.10536C151.91 6.75992 166.892 5.82869 176.793 6.39995C178.825 6.51286 178.936 8.8292 178.87 8.66151Z",
    fill: "url(#paint2_linear_436_29128)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.471 159.154C213.471 159.154 171.706 148.676 127.578 154.995C115.163 156.772 104.166 163.997 97.4659 174.599C85.3923 193.703 68.326 227.747 71.9358 263.25L90.8835 267.936C90.8835 267.936 103.979 225.8 118.72 208.651C118.72 208.651 136.175 248.438 135.292 270.286C135.267 270.903 135.228 271.506 135.172 272.094C133.169 293.47 218.961 276.083 218.961 276.083L213.471 159.154Z",
    fill: "url(#paint3_linear_436_29128)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.315 123.49L177.206 151.812C178.034 154.447 177.206 157.269 175.145 158.855C170.386 162.521 160.979 168.358 149.485 168.189C147.382 168.159 145.615 166.363 145.467 164.164L142.308 116.828L168.315 123.49Z",
    fill: "url(#paint4_linear_436_29128)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.899 92.4387C133.899 92.4387 130.445 114.744 132.62 125.403C134.796 136.062 134.322 143.473 147.025 142.395C159.728 141.318 168.37 132.579 171.165 120.658C171.165 120.658 175.614 102.251 171.931 96.1591C168.247 90.0676 133.899 92.4387 133.899 92.4387Z",
    fill: "url(#paint5_linear_436_29128)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M165.037 114.23L163.501 114.633C163.501 114.633 166.417 99.9886 160.259 99.1737C154.1 98.3587 130.898 99.6499 124.094 93.0843C117.534 86.7546 119.063 75.951 124.459 71.6201C124.629 71.4919 124.84 71.4322 125.051 71.4529C125.263 71.4736 125.458 71.5733 125.6 71.7319L126.357 72.557C126.473 72.6824 126.623 72.7706 126.788 72.81C126.954 72.8495 127.128 72.8384 127.287 72.7783C127.446 72.7182 127.584 72.6117 127.682 72.4726C127.781 72.3336 127.835 72.1683 127.839 71.998C127.857 71.2702 128.733 70.8801 129.259 71.3831C131.327 73.3373 136.263 76.103 147.339 75.2769C163.053 74.1053 174.555 77.5675 177.523 87.8614C177.565 88.0076 177.645 88.1399 177.756 88.2446C177.866 88.3493 178.002 88.4225 178.151 88.4567C178.299 88.491 178.454 88.4849 178.599 88.4392C178.744 88.3935 178.874 88.3098 178.976 88.1967C179.906 87.232 181.593 86.4505 184.483 87.8178C189.507 90.1978 190.184 99.6163 183.1 109.37C182.765 109.834 182.942 110.503 183.487 110.683C185.402 111.318 188.505 113.21 183.075 118.248C177.52 123.4 173.597 124.027 172.057 124.037C171.857 124.04 171.663 123.973 171.507 123.847C171.352 123.721 171.246 123.545 171.208 123.349L169.363 114.021C169.341 113.907 169.295 113.798 169.229 113.702C169.163 113.606 169.078 113.525 168.979 113.463C168.881 113.401 168.77 113.36 168.655 113.343C168.54 113.325 168.422 113.332 168.31 113.361L165.037 114.23Z",
    fill: "url(#paint6_linear_436_29128)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.158 116.257C165.158 116.257 165.124 102.597 171.798 104.676C178.472 106.756 172.587 119.783 168.109 121.473L165.158 116.257Z",
    fill: "url(#paint7_linear_436_29128)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.216 244.333C215.066 231.269 201.537 212.067 195.942 204.78C194.336 202.697 193.452 200.149 193.423 197.519C193.259 179.017 201.025 167.135 213.475 159.156C213.475 159.156 258.651 211.788 247.148 252.271C246.006 256.37 244.105 260.219 241.544 263.619C239.732 248.364 222.101 245.038 213.216 244.333Z",
    fill: "url(#paint8_linear_436_29128)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.364 239.278L214.086 239.081C212.633 226.271 201.385 210.454 196.619 204.25L195.246 205.305C199.923 211.401 210.957 226.898 212.364 239.278Z",
    fill: "url(#paint9_linear_436_29128)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.856 246.145C213.011 245.55 213.13 244.946 213.211 244.336C222.096 245.04 239.727 248.367 241.539 263.621C221.378 290.285 165.811 280.665 165.811 280.665V270.29C165.811 270.29 208.483 262.361 212.856 246.145Z",
    fill: "url(#paint10_linear_436_29128)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.148 277.796C171.148 277.796 162.944 258.434 148.487 265.302C134.03 272.169 135.161 276.663 135.161 276.663L171.148 277.796Z",
    fill: "url(#paint11_linear_436_29128)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173 281.812C172.944 282.517 172.619 283.174 172.091 283.645C171.564 284.116 170.875 284.365 170.168 284.34L95.2515 281.726C94.6834 281.707 94.1356 281.511 93.6836 281.166C93.2316 280.822 92.8978 280.345 92.7284 279.802L90.554 272.844C90.4292 272.445 90.3973 272.023 90.4607 271.609C90.5241 271.196 90.6812 270.803 90.9199 270.459C91.1586 270.116 91.4726 269.832 91.8379 269.628C92.2033 269.424 92.6103 269.307 93.028 269.285L120.347 267.832C120.595 267.819 120.843 267.84 121.086 267.893L170.857 278.924C171.502 279.067 172.074 279.438 172.467 279.968C172.861 280.499 173.05 281.154 173 281.812Z",
    fill: "url(#paint12_linear_436_29128)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.773 279.074L120.711 269.469L92.6487 270.808L94.4955 278.778L122.773 279.074Z",
    fill: "url(#paint13_linear_436_29128)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 175.689C138.748 188.667 145.893 241.392 147.938 256.458C148.005 256.955 147.963 257.462 147.815 257.941C147.667 258.421 147.416 258.863 147.079 259.236C146.743 259.609 146.33 259.905 145.868 260.102C145.406 260.299 144.907 260.393 144.405 260.378L23.2039 256.913C22.4332 256.89 21.692 256.611 21.0975 256.12C20.503 255.629 20.0892 254.954 19.9217 254.202L1.06786 169.293C0.952057 168.77 0.959061 168.227 1.08833 167.707C1.21761 167.188 1.46562 166.705 1.81291 166.297C2.1602 165.889 2.59731 165.567 3.0899 165.357C3.58249 165.146 4.11717 165.053 4.65193 165.084L133.924 172.656C134.733 172.703 135.5 173.033 136.091 173.587C136.682 174.141 137.06 174.885 137.16 175.689Z",
    fill: "url(#paint14_linear_436_29128)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4469 228.933L106.359 279.775L64.7077 280.658L61.2421 229.233C61.2038 228.665 61.2873 228.095 61.4871 227.562C61.6869 227.029 61.9984 226.545 62.4007 226.142C62.803 225.739 63.2867 225.426 63.8196 225.225C64.3524 225.025 64.922 224.94 65.4902 224.977L84.9421 226.269C85.7229 226.321 86.4712 226.601 87.0942 227.075C87.7172 227.548 88.1875 228.194 88.4469 228.933Z",
    fill: "url(#paint15_linear_436_29128)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.244 280.504C123.35 280.828 123.378 281.174 123.326 281.512C123.273 281.85 123.141 282.17 122.94 282.447C122.739 282.724 122.476 282.949 122.172 283.104C121.867 283.26 121.53 283.341 121.188 283.341H55.9593C55.3855 283.341 54.8353 283.113 54.4296 282.707C54.024 282.302 53.7961 281.751 53.7961 281.178V278.383C53.7959 278.091 53.8549 277.802 53.9695 277.533C54.084 277.265 54.2517 277.022 54.4625 276.82C54.6733 276.618 54.9228 276.461 55.196 276.358C55.4691 276.255 55.7604 276.208 56.052 276.221L121.281 279.016C121.721 279.034 122.144 279.187 122.495 279.453C122.846 279.719 123.107 280.085 123.244 280.504Z",
    fill: "url(#paint16_linear_436_29128)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.992 229.318L139.852 229.206L133.896 182.243C133.717 180.83 133.05 179.524 132.01 178.551C130.97 177.577 129.623 176.997 128.202 176.911L16.4896 170.164L16.437 171.029L128.149 177.775C129.369 177.85 130.524 178.348 131.416 179.183C132.308 180.019 132.881 181.139 133.037 182.351L138.992 229.318Z",
    fill: "#91B3FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.043 244.581L142.375 254.727L141.517 254.839L140.185 244.694L141.043 244.581Z",
    fill: "#91B3FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.788 130.647C159.247 131.664 167.07 117.747 167.148 117.606L166.246 117.109C166.172 117.245 158.659 130.587 145.865 129.621L145.788 130.647Z",
    fill: "url(#paint17_linear_436_29128)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.299 130.132C140.299 130.515 140.451 130.882 140.722 131.153C140.993 131.424 141.36 131.576 141.743 131.576H145.595C145.978 131.576 146.345 131.424 146.616 131.153C146.887 130.882 147.039 130.515 147.039 130.132C147.039 129.942 147.002 129.754 146.929 129.579C146.857 129.404 146.75 129.244 146.616 129.11C146.482 128.976 146.323 128.87 146.148 128.797C145.972 128.725 145.784 128.687 145.595 128.688H141.743C141.554 128.687 141.366 128.725 141.191 128.797C141.015 128.87 140.856 128.976 140.722 129.11C140.588 129.244 140.481 129.404 140.409 129.579C140.336 129.754 140.299 129.942 140.299 130.132Z",
    fill: "url(#paint18_linear_436_29128)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.218 102.179C166.218 102.179 161.387 77.4017 147.155 75.0641C147.155 75.0641 151.179 73.0351 155.387 75.2352C159.595 77.4352 170.21 89.4965 169.776 102.791C166.887 103.831 166.218 102.179 166.218 102.179Z",
    fill: "url(#paint19_linear_436_29128)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M168.702 101.004C176.101 102.506 175.186 111.863 175.186 111.863C175.72 118.653 173.733 122.019 171.198 123.623C170.344 124.16 169.366 124.467 168.359 124.514C167.352 124.562 166.35 124.348 165.45 123.893C164.55 123.439 163.782 122.76 163.222 121.921C162.663 121.083 162.329 120.114 162.254 119.108C162.117 117.26 161.96 115.504 161.824 114.88C161.494 113.369 161.303 99.5008 168.702 101.004Z",
    fill: "url(#paint20_linear_436_29128)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.015 103.363C168.76 103.232 169.528 103.357 170.193 103.716C170.859 104.075 171.384 104.648 171.683 105.343C176.106 115.588 170.677 122.25 168.011 122.39C165.202 122.537 165.259 109.021 165.856 105.555C166.105 104.104 167.029 103.534 168.015 103.363Z",
    fill: "url(#paint21_linear_436_29128)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0382 115.244C27.1062 115.244 6.0842 94.2219 6.0842 68.2899C6.0842 42.358 27.1062 21.3359 53.0382 21.3359C78.9702 21.3359 99.9922 42.358 99.9922 68.2899C99.9922 94.2219 78.9702 115.244 53.0382 115.244Z",
    fill: "url(#paint22_linear_436_29128)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0383 108.79C30.8732 108.79 12.9048 90.8221 12.9048 68.657C12.9048 46.4918 30.8732 28.5234 53.0383 28.5234C75.2035 28.5234 93.1719 46.4918 93.1719 68.657C93.1719 90.8221 75.2035 108.79 53.0383 108.79Z",
    fill: "url(#paint23_linear_436_29128)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6074 100.793C36.3669 100.793 20.7695 85.1955 20.7695 65.9551C20.7695 46.7146 36.3669 31.1172 55.6074 31.1172C74.8478 31.1172 90.4453 46.7146 90.4453 65.9551C90.4453 85.1955 74.8478 100.793 55.6074 100.793Z",
    fill: "#91B3FA"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 15.5639C51.9305 16.7656 43.6188 20.6929 42.0268 21.4464C41.9962 21.4609 41.9694 21.4825 41.9486 21.5092C41.9279 21.536 41.9136 21.5673 41.9071 21.6005C41.9006 21.6338 41.9019 21.6681 41.9111 21.7008C41.9202 21.7334 41.9369 21.7634 41.9598 21.7885L51.897 32.6648C52.1028 32.8897 52.3592 33.0626 52.6449 33.1691C52.9306 33.2756 53.2375 33.3127 53.5404 33.2774L57.8063 32.7799C57.8426 32.7761 57.8773 32.7631 57.9071 32.7422C57.937 32.7214 57.9611 32.6933 57.9772 32.6605C57.9932 32.6278 58.0008 32.5916 57.9991 32.5552C57.9973 32.5188 57.9864 32.4834 57.9673 32.4524L52.3967 23.31C52.3802 23.2829 52.3697 23.2526 52.3662 23.221C52.3626 23.1895 52.366 23.1576 52.3762 23.1275C52.3863 23.0975 52.4029 23.07 52.4248 23.0471C52.4467 23.0241 52.4734 23.0063 52.5029 22.9947L60.5766 19.8478C60.7212 19.7915 60.8463 19.6943 60.9366 19.5681C61.0269 19.4419 61.0786 19.2921 61.0852 19.1371C61.0918 18.982 61.0532 18.8284 60.974 18.6949C60.8948 18.5615 60.7785 18.454 60.6392 18.3855L54.931 15.5683C54.9028 15.555 54.8722 15.5477 54.841 15.5469C54.8098 15.5462 54.7788 15.5519 54.75 15.5639Z",
    fill: "url(#paint24_linear_436_29128)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5425 75.9934H31.911V73.2411L35.437 68.2506C36.4058 66.8771 37.0702 65.8575 37.4302 65.192C37.7671 64.5865 38.0356 63.9453 38.2307 63.2803C38.4026 62.6646 38.4891 62.0281 38.4878 61.3888C38.4878 60.6294 38.3182 60.0596 37.9791 59.6795C37.8142 59.4931 37.6101 59.3455 37.3815 59.2471C37.1528 59.1488 36.9053 59.1021 36.6566 59.1105C36.1826 59.1088 35.7178 59.2405 35.3151 59.4906C34.8992 59.7432 34.3928 60.1997 33.7958 60.86L31.7344 58.6901C32.6839 57.6147 33.5655 56.878 34.3794 56.48C35.2028 56.0797 36.1077 55.8753 37.0233 55.883C38.6234 55.883 39.8733 56.3533 40.7728 57.2938C41.6724 58.2344 42.1221 59.5386 42.1221 61.2066C42.1257 61.9325 42.0439 62.6563 41.8784 63.3631C41.7059 64.0678 41.4578 64.7518 41.1384 65.4033C40.776 66.1398 40.3617 66.8496 39.8986 67.5273C39.4015 68.2644 38.1177 69.9525 36.0473 72.5915V72.7033H42.5425V75.9934Z",
    fill: "#E7EFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2207 71.8418H54.2084V76.005H50.7429V71.8418H44.2734V68.8447L50.2677 56.1797H54.214V68.7899H56.2263L56.2207 71.8418ZM50.7429 68.791V64.6144L50.8099 62.7699L50.905 61.0069H50.7932C50.5058 61.9182 50.1615 62.8105 49.7624 63.6787L47.3757 68.791H50.7429Z",
    fill: "#E7EFFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7077 56.1797L60.3172 76.005H56.8438L64.2344 56.1797H67.7077Z",
    fill: "#E7EFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3092 75.9938L75.8697 59.463H68.9531V56.1953H79.5846V58.6905L74.1202 75.9938H70.3092Z",
    fill: "#E7EFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_436_29128",
    x1: -19.281,
    y1: 358.913,
    x2: 199.442,
    y2: 126.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_436_29128",
    x1: 26.8308,
    y1: 338.267,
    x2: 292.657,
    y2: -10.5775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_436_29128",
    x1: 152.664,
    y1: -104.22,
    x2: 161.778,
    y2: 8.17968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_436_29128",
    x1: 133.725,
    y1: 199.585,
    x2: 231.953,
    y2: 326.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_436_29128",
    x1: 176.025,
    y1: 193.849,
    x2: 155.619,
    y2: 138.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_436_29128",
    x1: 136.73,
    y1: 110.527,
    x2: 196.553,
    y2: 135.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_436_29128",
    x1: 140.24,
    y1: 47.853,
    x2: 165.397,
    y2: 123.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_436_29128",
    x1: 140.781,
    y1: 100.838,
    x2: 200.604,
    y2: 125.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_436_29128",
    x1: 182.578,
    y1: 161.84,
    x2: 280.806,
    y2: 288.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_436_29128",
    x1: 45.2613,
    y1: 110.363,
    x2: 349.19,
    y2: 322.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_436_29128",
    x1: 217.956,
    y1: 229.359,
    x2: 185.027,
    y2: 316.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_436_29128",
    x1: 177.1,
    y1: 213.828,
    x2: 144.17,
    y2: 300.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_436_29128",
    x1: 180.736,
    y1: 265.028,
    x2: 101.753,
    y2: 284.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_436_29128",
    x1: 178.992,
    y1: 257.807,
    x2: 100.009,
    y2: 276.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_436_29128",
    x1: 46.326,
    y1: 230.386,
    x2: 176.513,
    y2: 148.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_436_29128",
    x1: 84.5945,
    y1: 287.174,
    x2: 83.054,
    y2: 224.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_436_29128",
    x1: 90.2348,
    y1: 181.862,
    x2: 89.4646,
    y2: 227.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_436_29128",
    x1: 167.649,
    y1: 134.868,
    x2: 150.022,
    y2: 117.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_436_29128",
    x1: 147.039,
    y1: 130.132,
    x2: 140.299,
    y2: 130.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_436_29128",
    x1: 108.77,
    y1: 70.839,
    x2: 255.984,
    y2: 121.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_436_29128",
    x1: 142.794,
    y1: 104.003,
    x2: 218.346,
    y2: 130.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_436_29128",
    x1: 181.854,
    y1: 66.2558,
    x2: 175.691,
    y2: 88.3382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_436_29128",
    x1: 75.6125,
    y1: 27.6567,
    x2: 21.6882,
    y2: 124.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_436_29128",
    x1: 93.1719,
    y1: 68.657,
    x2: 12.9037,
    y2: 68.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_436_29128",
    x1: 33.354,
    y1: -126.418,
    x2: 41.8278,
    y2: -57.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer_support.7fb1214ee37c73f0b9ef52f61e011e86.svg";
export { ForwardRef as ReactComponent };